import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  zh: {
    translation: {
      common: {
        loading: '加载中...',
        error: '错误',
        retry: '重试',
        not_found: '未找到',
        success: '成功',
        theme: '主题',
      },
      purchase_channels: {
        title: '购买渠道地图',
        description:
          '我们基于用户常见决策路径，梳理了海外与国内一二线城市的主流正规购买渠道。后续将与品牌详情、评分、证据链打通，提供就近门店与可信电商入口。',
        tab_overseas: '海外渠道',
        tab_china: '国内一二线',
        disclaimer: '免责声明：部分平台为第三方渠道，请注意售后与鉴定政策。',
        tags: {
          official: '官方',
          authentic: '正品保障',
          selection: '选择多',
          global_shipping: '全球配送',
          offline_experience: '线下体验',
          watches: '腕表',
          jewelry: '珠宝',
          secondhand: '二奢',
          appointment: '线下预约',
          duty_free: '免税',
        },
        items: {
          overseas: {
            dtc: {
              title: '品牌直营 DTC',
              desc: '品牌官网与 App，部分直接下单，部分引导线下预约（LV/Chanel/Hermès 等）。',
            },
            multibrand: {
              title: '多品牌电商',
              desc: 'Farfetch / SSENSE / Mytheresa / Net‑A‑Porter / Mr Porter / Flannels 等。',
            },
            department: {
              title: '百货/精品店',
              desc: 'Harrods / Selfridges / Saks / Neiman Marcus / Lafayette / Printemps。',
            },
            watches: {
              title: '腕表/珠宝经销与二级市场',
              desc: 'Watches of Switzerland / Bucherer / Wempe；二级：Chrono24 / WatchBox。',
            },
            resale: {
              title: '二手/寄售',
              desc: 'The RealReal / Vestiaire Collective / Fashionphile / Rebag。',
            },
          },
          china: {
            official: {
              title: '品牌官网/小程序/门店',
              desc: '官网 + 微信小程序 + 线下精品店（SKP/恒隆/IFC/太古里/K11/万象城等）。',
            },
            platform: {
              title: '平台电商',
              desc: '天猫奢品（Luxury Pavilion）/ 京东奢品 / Farfetch 中国 / 小程序直连。',
            },
            watches: {
              title: '腕表/珠宝渠道',
              desc: '中免免税（CDF/离岛）/ 经销商网络（亨得利等）/ 跨境平台 Chrono24。',
            },
            resale: {
              title: '二手/寄售',
              desc: '红布林（Plum）/ 只二 / 胖虎 / 妃鱼 / 闲鱼高端频道（注意鉴定）。',
            },
          },
        },
      },
      brand_card: {
        view_details: '查看详情',
        favorite: '收藏',
        favorited: '已收藏',
        website: '官网',
        founded: '成立于',
        headquarters: '总部',
        login_to_favorite: '请先登录后再收藏品牌',
        favorite_success: '收藏成功',
        unfavorite_success: '已取消收藏',
        operation_failed: '操作失败',
      },
      rating_display: {
        overall_card: '综合评分',
        total_score: '总分',
        confidence: '置信度',
        data_sources: '数据来源:',
        dimensions_card: '各维度评分',
        dimension_environmental: '环保表现',
        dimension_laborRights: '劳工权益',
        dimension_animalWelfare: '动物福利',
        dimension_transparency: '透明度',
        dimension_socialResponsibility: '社会责任',
        dimension_carbonFootprint: '碳足迹',
        last_updated: '最后更新',
      },
      badges: {
        title: '认证徽章',
        title_with_count: '认证徽章 ({{count}})',
        empty_title: '认证徽章',
        empty_desc: '该品牌暂无认证信息',
        summary_category: '认证分类统计',
        summary_level: '认证等级统计',
        valid_until: '有效至',
        verify: '验证证书 →',
        category_environmental: '环境',
        category_social: '社会',
        category_governance: '治理',
        category_quality: '质量',
        disclaimer: '认证信息由第三方机构提供，LuxEthics定期更新验证状态',
        bcorp_desc: '通过严格的社会和环境绩效、责任和透明度标准的企业认证',
        gots_desc: '全球有机纺织品标准，确保纺织品的有机纤维含量和环保生产',
        fairtrade_desc: '确保生产者获得公平价格和良好工作条件的认证',
        cradle2cradle_desc: '从摇篮到摇篮的循环经济设计认证',
        bcorp_name: 'B Corp认证',
        gots_name: 'GOTS有机纺织品',
        fairtrade_name: 'Fair Trade公平贸易',
        cradle2cradle_name: 'Cradle to Cradle',
        rainforest_name: 'Rainforest Alliance',
        leed_name: 'LEED绿色建筑',
        rainforest_desc: '雨林联盟认证，保护生物多样性和可持续农业',
        leed_desc: '领先的绿色建筑认证系统',
      },
      brand_detail: {
        loading_brand: '加载品牌中...',
        load_failed: '加载失败',
        not_found: '品牌未找到',
        back_to_list: '返回列表',
        founded: '成立于',
        headquarters: '总部',
        website: '官网',
        rate_this_brand: '评价此品牌',
        view_on_map: '在地图上查看',
        compare_brands: '对比品牌',
        business_categories: '业务类别',
        brand_map: '品牌地图',
        unknown: '未知',
        no_rating: '暂无评分数据',
        similar_brands: '相似品牌',
        loading_similar: '加载相似品牌中...',
        view_details: '查看详情',
        similarity: '相似度',
        no_similar_brands: '未找到相似品牌',
      },
      purchase_entry: {
        title: '购买入口',
        description: '我们为你整理了该品牌的正规购买渠道。请优先选择官方渠道或信誉良好的平台。',
        group: '集团',
        headquarters: '总部',
        category_hard: '品类：腕表/珠宝',
        category_soft: '品类：成衣/皮具/香化',
        official_site: '官方网站',
        overseas: '海外渠道',
        watches_section: '腕表/珠宝经销与二级市场',
        china: '国内一二线渠道',
      },
      recommendations: {
        title: '品牌推荐',
        load_failed: '加载推荐失败',
        tab_personal: '为您推荐',
        tab_trending: '热门品牌',
        personal_desc: '基于您的偏好和浏览历史为您推荐',
        trending_desc: '根据道德评分和用户关注度排序',
        view_details: '查看详情',
        founded_short: '成立于',
        headquarters_short: '总部',
        reasons_title: '推荐理由:',
        personal_empty: '暂无个性化推荐，请先设置您的偏好或浏览一些品牌',
        trending_empty: '暂无热门品牌数据',
      },
      home: {
        subtitle: '探索可持续与道德的奢侈品牌',
        explore: '探索品牌',
        recommendations: '个性化推荐',
        map: '全球地图',
        popular: '热门品牌',
        view_more: '查看更多',
        popular_top: '评分最高',
        popular_trending: '正在流行',
        top_rated_badge: 'Top Rated',
      },
      brands: {
        title: '品牌列表',
        all: '全部',
        search_placeholder: '搜索品牌、关键字…',
        select_category: '选择类别',
        fashion: '时装',
        accessories: '配饰',
        leather: '皮具',
        jewelry: '珠宝',
        filter: '筛选',
        add_brand: '新增品牌',
        loading_failed: '加载品牌失败',
        no_data: '暂无品牌数据',
        pagination_total: '第 {{start}}-{{end}} 条，共 {{total}} 条',
      },
      ratebrand: {
        page_title: '为 {{name}} 打分',
        login_required: '请先登录后再进行评分',
        load_brand_failed: '加载品牌信息失败',
        submitting_success: '提交评分成功',
        submitting_failed: '提交评分失败',
        network_error: '网络错误，请稍后再试',
        dimension_environmental: '环保表现',
        desc_environmental: '材料可持续性、污染控制、减排与循环利用等',
        dimension_labor_rights: '劳工权益',
        desc_labor_rights: '安全与健康、工资与福利、平等与反歧视、供应链劳动',
        dimension_animal_welfare: '动物福利',
        desc_animal_welfare: '无虐待、无皮草与异地替代材料、实验替代',
        dimension_transparency: '透明度',
        desc_transparency: '供应链披露、数据公开、第三方验证',
        dimension_social_responsibility: '社会责任',
        desc_social_responsibility: '社区贡献、慈善与公益、合规与道德',
        dimension_carbon_footprint: '碳足迹',
        desc_carbon_footprint: '碳排放强度、减碳计划与进展、再生能源使用',
        mark_1: '较弱',
        mark_5: '一般',
        mark_10: '优秀',
        submit_btn: '提交评分',
        cancel_btn: '返回',
      },
      worldmap: {
        title: '品牌世界地图',
        by_country: '按国家/地区查看',
        select_country_placeholder: '选择国家或地区',
        summary_total: '共 {{total}} 个国家/地区，含坐标 {{withCoords}} 个',
        popup_brands_count: '品牌数量：{{count}}',
        country_brand_list: '该国家/地区的品牌',
        view: '查看',
        headquarters: '总部',
        empty_country: '该国家/地区暂无品牌',
        empty_hint: '请选择一个国家/地区以查看品牌',
      },
      rankings: {
        title: '道德评分排行榜',
        sort_dimension: '按维度排序',
        dimension_overall: '综合评分',
        dimension_environmental: '环保表现',
        dimension_laborRights: '劳工权益',
        dimension_animalWelfare: '动物福利',
        dimension_transparency: '透明度',
        dimension_socialResponsibility: '社会责任',
        dimension_carbonFootprint: '碳足迹',
        col_rank: '排名',
        col_brand: '品牌',
        col_score: '评分',
        col_founded: '创立年份',
        col_headquarters: '总部',
        pagination_total: '第 {{start}}-{{end}} 条，共 {{total}} 条',
      },
      user_reviews: {
        title: '用户评价',
        write_review: '写评价',
        edit_review: '编辑评价',
        update_review: '更新评价',
        publish_review: '发布评价',
        cancel: '取消',
        empty: '暂无评价',
        pagination_total: '第 {{start}}-{{end}} 条，共 {{total}} 条',
        pros_label: '优点',
        cons_label: '缺点',
        delete_confirm_title: '确认删除',
        delete_confirm_content: '确定要删除这条评论吗？',
        delete_success: '删除成功',
        delete_failed: '删除失败',
        load_failed: '加载评论失败',
        submit_failed: '提交评论失败',
        update_success: '评论更新成功',
        publish_success: '评论发布成功',
        login_required: '请先登录',
        action_failed: '操作失败',
      },
      profile: {
        title: '个人资料',
        logout: '退出登录',
        loading_user: '加载用户信息...',
        overview: '概览',
        basic_info: '基本信息',
        edit_profile: '编辑资料',
        email: '邮箱',
        username: '用户名',
        unset: '未设置',
        registered_at: '注册日期',
        last_active: '最近活跃',
        quick_links: '快捷入口',
        my_favorites: '我的收藏',
        browsing_history: '浏览历史',
        my_reviews: '我的评价',
        my_ratings: '我的评分',
        dashboard: '仪表板',
        my_activities: '我的活动',
        my_contributions: '我的贡献',
        view_all: '查看全部',
        open: '打开',
        settings: '设置',
        preferences: '偏好设置',
        theme_setting: '主题配色',
        dark_mode: '深色模式',
        language_setting: '界面语言',
        currency_setting: '货币单位',
        categories_followed: '关注的类别',
        not_set_categories: '尚未关注任何类别',
        notifications: '通知设置',
        email_notifications: '邮件通知',
        push_notifications: '推送通知',
        new_recommendations: '新推荐提醒',
        rating_updates: '评分更新提醒',
        community_updates: '社区动态提醒',
      },
      editprofile: {
        title: '编辑资料',
        basic_info: '基本信息',
        username_label: '用户名',
        username_required: '请输入用户名',
        username_placeholder: '请输入用户名',
        email_label: '邮箱',
        email_required: '请输入邮箱',
        email_invalid: '邮箱格式不正确',
        email_placeholder: '请输入邮箱地址',
        save_changes: '保存修改',
        cancel: '取消',
        change_password: '修改密码',
        current_password: '当前密码',
        current_password_required: '请输入当前密码',
        current_password_placeholder: '当前密码',
        new_password: '新密码',
        new_password_required: '请输入新密码',
        new_password_min: '密码至少 6 位',
        new_password_placeholder: '新密码',
        confirm_password: '确认新密码',
        confirm_password_required: '请再次输入新密码',
        confirm_password_mismatch: '两次输入的密码不一致',
        confirm_password_placeholder: '确认新密码',
        update_success: '资料已更新',
        update_failed: '更新失败',
        change_password_success: '密码修改成功',
        change_password_failed: '密码修改失败',
        network_error: '网络错误，请稍后重试',
      },
      dashboard: {
        title: '个人仪表板',
        please_login_title: '请先登录',
        please_login_desc: '登录后可查看您的评分、收藏与浏览数据概览。',
        last_7_days: '近 7 天',
        last_30_days: '近 30 天',
        last_3_months: '近 3 个月',
        last_1_year: '近 1 年',
        refresh: '刷新',
        total_ratings: '评分次数',
        total_favorites: '收藏总数',
        total_browsed: '浏览次数',
        average_rating: '平均评分',
        distribution: '类别分布',
        activity_trends: '活动趋势',
        ratings_count: '评分',
        favorites_count: '收藏',
        my_top_brands: '我最常互动的品牌',
        industry_comparison: '行业对比',
        industry_avg: '行业平均',
        my_avg: '我的平均',
        highlight_title: '亮点',
        highlight_text:
          '共 {{ratings}} 次评分、{{favorites}} 次收藏，平均 {{avg}} 分',
        insights_title: '个人洞察',
        insights_env_title: '环保意识',
        insights_env_desc: '您偏爱环保认证品牌',
        insights_social_title: '社会责任',
        insights_social_desc: '关注劳工权益品牌',
        insights_animal_title: '动物保护',
        insights_animal_desc: '支持零残忍品牌',
      },
      myratings: {
        title: '我的评分记录',
        login_required: '请先登录后查看评分记录',
        loading_failed: '加载评分记录失败',
        col_brand: '品牌',
        col_overall: '综合评分',
        col_dimensions: '维度评分',
        col_time: '时间',
        col_actions: '操作',
        view_brand: '查看品牌',
        re_rate: '重新评分',
        delete_rating: '删除评分',
        confirm_delete_title: '确认删除评分',
        confirm_delete_content: '删除后将无法恢复，是否继续？',
        confirm_ok: '删除',
        confirm_cancel: '取消',
        delete_success: '删除成功',
        delete_failed: '删除失败',
        empty_title: '暂无评分记录',
        empty_go_to: '去 {{page}} 发现更多品牌',
        pagination_total: '第 {{start}}-{{end}} 条，共 {{total}} 条',
      },
      myreviews: {
        title: '我的评价',
        loading_failed: '加载评价失败',
        sort_label: '排序',
        sort_latest: '最新',
        sort_oldest: '最早',
        view_brand: '查看品牌',
        edit: '编辑',
        delete: '删除',
        pros_label: '优点',
        cons_label: '缺点',
        empty_title: '暂无评价内容',
        edit_modal_title: '编辑评价',
        save: '保存',
        form_content_label: '评价内容',
        content_required: '请输入评价内容',
        content_placeholder: '写下你的真实体验...',
        pros_placeholder: '每行一条优点',
        cons_placeholder: '每行一条缺点',
        confirm_delete_title: '确认删除这条评价？',
        confirm_delete_content: '删除后将无法恢复',
        delete_success: '删除成功',
        delete_failed: '删除失败',
      },
      favorites: {
        title: '我的收藏',
        loading_failed: '加载收藏失败',
        empty: '暂无收藏，去发现喜欢的品牌吧',
        go_discover: '去发现',
        total: '已收藏 {{count}} 个品牌',
        category_distribution: '按类别：',
        remove_favorite: '取消收藏',
        founded_short: '成立于',
        headquarters_short: '总部',
        ethical_score: '道德评分',
      },
      history: {
        title: '浏览历史',
        loading_failed: '加载历史失败',
        empty_desc: '暂无浏览记录',
        discover: '去发现',
        view_details: '查看详情',
        confirm_clear_title: '确认清空浏览历史？',
        confirm_ok: '清空',
        confirm_cancel: '取消',
        clear_history: '清空历史',
        days_ago: '{{count}} 天前',
        hours_ago: '{{count}} 小时前',
        just_now: '刚刚',
        visited_times: '访问 {{count}} 次',
        stayed_seconds: '停留 {{seconds}} 秒',
      },
      nav: {
        home: '首页',
        brands: '品牌',
        rankings: '排行榜',
        worldMap: '世界地图',
        recommendations: '推荐',
        about: '关于',
      },
      user: {
        profile: '个人资料',
        favorites: '我的收藏',
        history: '浏览历史',
        myRatings: '我的评分',
        myReviews: '我的评价',
        dashboard: '仪表板',
        login: '登录',
        register: '注册',
        logout: '退出登录',
      },
      login: {
        title: '登录',
        subtitle: '欢迎回来，请输入邮箱和密码',
        email_required: '请输入邮箱',
        email_invalid: '邮箱格式不正确',
        email_placeholder: '邮箱地址',
        password_required: '请输入密码',
        password_placeholder: '密码',
        forgot_password: '忘记密码？',
        submit: '登录',
        no_account: '还没有账号？',
        register_now: '立即注册',
        back_home: '返回首页',
      },
      register: {
        title: '注册',
        subtitle: '创建您的 LuxEthics 账户',
        email_required: '请输入邮箱',
        email_invalid: '邮箱格式不正确',
        email_placeholder: '邮箱地址',
        username_placeholder: '用户名（可选）',
        password_required: '请输入密码',
        password_min: '密码长度至少 8 位',
        password_rules: '需包含大小写字母、数字与特殊符号',
        password_placeholder: '设置密码',
        confirm_password_required: '请再次输入密码',
        confirm_password_mismatch: '两次输入的密码不一致',
        confirm_password_placeholder: '确认密码',
        submit: '注册',
        have_account: '已经有账号？',
        login_now: '立即登录',
        back_home: '返回首页',
      },
      brand: 'LuxEthics',
      about: {
        title: '关于 LuxEthics',
        subtitle: '我们的使命是用数据推动更可持续、更有责任感的消费选择。',
        note: '本项目处于持续迭代阶段，数据来源和算法会不断完善。',
        why_title: '为什么要做这个网站',
        why_p1:
          '时尚与奢侈品行业在环境、劳工权益、动物福利、供应链透明度等方面影响深远。',
        why_p2:
          '消费者缺乏便捷、可信、可比的道德与可持续信息，难以做出知情选择。',
        why_p3: '我们希望降低信息壁垒，让每一次消费都更接近负责任的选择。',
        how_title: '我们如何做',
        highlights_transparency_title: '供应链透明',
        highlights_transparency_desc:
          '整合公开报告与认证数据，呈现品牌在透明度方面的表现。',
        highlights_workers_title: '尊重劳工',
        highlights_workers_desc: '关注工人安全、工资、公平贸易与社会责任。',
        highlights_environment_title: '环境友好',
        highlights_environment_desc: '评估环保材料、减排与循环利用等指标。',
        how_data_sources:
          '数据来源包括第三方认证、机构报告、品牌公开信息与用户贡献的证据。',
        impact_title: '社会意义',
        impact_p1: '帮助消费者用钱包投票，鼓励品牌提升可持续与道德标准。',
        impact_p2: '促进行业透明、推动更公平与可持续的全球供应链。',
        join_title: '加入我们',
        join_contribute: '贡献数据与证据，或参与翻译与术语统一。',
        join_feedback: '提出建议与反馈，共同改进产品体验与评估方法。',
      },
      footer: {
        slogan: '用数据与透明，连接良知与美感',
        links: '快速链接',
        about: '关于我们',
        browse_brands: '浏览品牌',
        world_map: '世界地图',
        legal: '说明与声明',
        disclaimer:
          '部分数据来源于第三方与公开资料，仅供参考，不构成投资或消费建议。',
        rights_reserved: '保留所有权利',
        contact: '联系我们',
        contact_email_label: '联系邮箱',
        privacy_policy: '隐私政策',
        terms_of_use: '使用条款',
      },
      legal: {
        privacy_title: '隐私政策',
        privacy_intro:
          '我们重视您的隐私，仅在必要时收集最少信息，并遵循相关法律法规。',
        terms_title: '使用条款',
        terms_intro: '使用本网站即表示您同意遵守我们的使用条款与社区规范。',
      },
    },
  },
  en: {
    translation: {
      common: {
        loading: 'Loading...',
        error: 'Error',
        retry: 'Retry',
        not_found: 'Not found',
        success: 'Success',
        theme: 'Theme',
      },
      brand_card: {
        view_details: 'View Details',
        favorite: 'Favorite',
        favorited: 'Favorited',
        website: 'Website',
        founded: 'Founded',
        headquarters: 'HQ',
        login_to_favorite: 'Please login to favorite brands',
        favorite_success: 'Added to favorites',
        unfavorite_success: 'Removed from favorites',
        operation_failed: 'Operation failed',
      },
      rating_display: {
        overall_card: 'Overall Rating',
        total_score: 'Score',
        confidence: 'Confidence',
        data_sources: 'Data sources:',
        dimensions_card: 'Dimension Scores',
        dimension_environmental: 'Environmental',
        dimension_laborRights: 'Labor Rights',
        dimension_animalWelfare: 'Animal Welfare',
        dimension_transparency: 'Transparency',
        dimension_socialResponsibility: 'Social Responsibility',
        dimension_carbonFootprint: 'Carbon Footprint',
        last_updated: 'Last updated',
      },
      badges: {
        title: 'Certifications',
        title_with_count: 'Certifications ({{count}})',
        empty_title: 'Certifications',
        empty_desc: 'This brand has no certification information yet',
        summary_category: 'Category Summary',
        summary_level: 'Level Summary',
        valid_until: 'Valid until',
        verify: 'Verify certificate →',
        category_environmental: 'Environmental',
        category_social: 'Social',
        category_governance: 'Governance',
        category_quality: 'Quality',
        disclaimer:
          'Certification information is provided by third-party organizations. LuxEthics regularly updates verification status.',
        bcorp_desc:
          'Corporate certification that meets rigorous standards of social and environmental performance, accountability and transparency',
        gots_desc:
          'Global Organic Textile Standard ensuring organic fiber content and environmentally friendly production of textiles',
        fairtrade_desc:
          'Certification ensuring producers receive fair prices and good working conditions',
        cradle2cradle_desc:
          'Cradle to cradle circular economy design certification',
        bcorp_name: 'B Corp Certification',
        gots_name: 'GOTS Organic Textiles',
        fairtrade_name: 'Fair Trade',
        cradle2cradle_name: 'Cradle to Cradle',
        rainforest_name: 'Rainforest Alliance',
        leed_name: 'LEED Green Building',
        rainforest_desc:
          'Rainforest Alliance certification protecting biodiversity and sustainable agriculture',
        leed_desc: 'Leading green building certification system',
      },
      brand_detail: {
        loading_brand: 'Loading brand...',
        load_failed: 'Load failed',
        not_found: 'Brand not found',
        back_to_list: 'Back to List',
        founded: 'Founded',
        headquarters: 'Headquarters',
        website: 'Website',
        rate_this_brand: 'Rate This Brand',
        view_on_map: 'View on Map',
        compare_brands: 'Compare Brands',
        business_categories: 'Business Categories',
        brand_map: 'Brand Map',
        unknown: 'Unknown',
        no_rating: 'No rating data available',
        similar_brands: 'Similar Brands',
        loading_similar: 'Loading similar brands...',
        view_details: 'View Details',
        similarity: 'Similarity',
        no_similar_brands: 'No similar brands found',
      },
      purchase_entry: {
        title: 'Purchase Channels',
        description:
          'We curated official and reputable purchase channels for this brand. Prefer official or trusted platforms.',
        group: 'Group',
        headquarters: 'HQ',
        category_hard: 'Category: Watches/Jewelry',
        category_soft: 'Category: Fashion/Leather/Cosmetics',
        official_site: 'Official Website',
        overseas: 'Overseas Channels',
        watches_section: 'Watch/Jewelry Dealers & Secondary Market',
        china: 'China Tier-1/2 Channels',
      },
      recommendations: {
        title: 'Brand Recommendations',
        load_failed: 'Failed to load recommendations',
        tab_personal: 'For You',
        tab_trending: 'Trending',
        personal_desc:
          'Recommended based on your preferences and browsing history',
        trending_desc: 'Sorted by ethical rating and user interest',
        view_details: 'View details',
        founded_short: 'Founded',
        headquarters_short: 'HQ',
        reasons_title: 'Reasons:',
        personal_empty:
          'No personal recommendations yet. Set your preferences or browse some brands first.',
        trending_empty: 'No trending brand data',
      },
      home: {
        subtitle: 'Explore sustainable and ethical luxury brands',
        explore: 'Explore Brands',
        recommendations: 'Recommendations',
        map: 'World Map',
        popular: 'Popular Brands',
        view_more: 'View More',
        popular_top: 'Top Rated',
        popular_trending: 'Trending',
        top_rated_badge: 'Top Rated',
      },
      brands: {
        title: 'Brands',
        all: 'All',
        search_placeholder: 'Search brands, keywords…',
        select_category: 'Select Category',
        fashion: 'Fashion',
        accessories: 'Accessories',
        leather: 'Leather Goods',
        jewelry: 'Jewelry',
        filter: 'Filter',
        add_brand: 'Add Brand',
        loading_failed: 'Failed to load brands',
        no_data: 'No brands found',
        pagination_total: 'Items {{start}}-{{end}} of {{total}}',
      },
      ratebrand: {
        page_title: 'Rate {{name}}',
        login_required: 'Please login before rating',
        load_brand_failed: 'Failed to load brand info',
        submitting_success: 'Rating submitted',
        submitting_failed: 'Failed to submit rating',
        network_error: 'Network error, please try again later',
        dimension_environmental: 'Environmental',
        desc_environmental:
          'Material sustainability, pollution control, decarbonization, circularity',
        dimension_labor_rights: 'Labor Rights',
        desc_labor_rights:
          'Safety & health, wages & benefits, equality, supply chain labor',
        dimension_animal_welfare: 'Animal Welfare',
        desc_animal_welfare:
          'No cruelty, no fur, alternative materials, testing alternatives',
        dimension_transparency: 'Transparency',
        desc_transparency:
          'Supply chain disclosure, data openness, third-party verification',
        dimension_social_responsibility: 'Social Responsibility',
        desc_social_responsibility:
          'Community contribution, philanthropy, compliance & ethics',
        dimension_carbon_footprint: 'Carbon Footprint',
        desc_carbon_footprint:
          'Emission intensity, decarbonization plan & progress, renewable usage',
        mark_1: 'Poor',
        mark_5: 'Average',
        mark_10: 'Excellent',
        submit_btn: 'Submit Rating',
        cancel_btn: 'Back',
      },
      worldmap: {
        title: 'World Map of Brands',
        by_country: 'By Country/Region',
        select_country_placeholder: 'Select a country or region',
        summary_total:
          '{{total}} countries/regions, {{withCoords}} with coordinates',
        popup_brands_count: 'Brands: {{count}}',
        country_brand_list: 'Brands in selected country/region',
        view: 'View',
        headquarters: 'Headquarters',
        empty_country: 'No brands in this country/region',
        empty_hint: 'Select a country/region to view brands',
      },
      rankings: {
        title: 'Ethical Rankings',
        sort_dimension: 'Sort by Dimension',
        dimension_overall: 'Overall',
        dimension_environmental: 'Environmental',
        dimension_laborRights: 'Labor Rights',
        dimension_animalWelfare: 'Animal Welfare',
        dimension_transparency: 'Transparency',
        dimension_socialResponsibility: 'Social Responsibility',
        dimension_carbonFootprint: 'Carbon Footprint',
        col_rank: 'Rank',
        col_brand: 'Brand',
        col_score: 'Score',
        col_founded: 'Founded',
        col_headquarters: 'Headquarters',
        pagination_total: 'Items {{start}}-{{end}} of {{total}}',
      },
      user_reviews: {
        title: 'User Reviews',
        write_review: 'Write Review',
        edit_review: 'Edit Review',
        update_review: 'Update Review',
        publish_review: 'Publish Review',
        cancel: 'Cancel',
        empty: 'No reviews yet',
        pagination_total: 'Items {{start}}-{{end}} of {{total}}',
        pros_label: 'Pros',
        cons_label: 'Cons',
        delete_confirm_title: 'Confirm deletion',
        delete_confirm_content: 'Are you sure to delete this review?',
        delete_success: 'Deleted successfully',
        delete_failed: 'Delete failed',
        load_failed: 'Failed to load reviews',
        submit_failed: 'Submit review failed',
        update_success: 'Review updated',
        publish_success: 'Review published',
        login_required: 'Please login first',
        action_failed: 'Action failed',
      },
      profile: {
        title: 'Profile',
        logout: 'Logout',
        loading_user: 'Loading user...',
        overview: 'Overview',
        basic_info: 'Basic Info',
        edit_profile: 'Edit Profile',
        email: 'Email',
        username: 'Username',
        unset: 'Unset',
        registered_at: 'Registered At',
        last_active: 'Last Active',
        quick_links: 'Quick Links',
        my_favorites: 'My Favorites',
        browsing_history: 'Browsing History',
        my_reviews: 'My Reviews',
        my_ratings: 'My Ratings',
        dashboard: 'Dashboard',
        my_activities: 'My Activities',
        my_contributions: 'My Contributions',
        view_all: 'View All',
        open: 'Open',
        settings: 'Settings',
        preferences: 'Preferences',
        theme_setting: 'Theme',
        dark_mode: 'Dark Mode',
        language_setting: 'Language',
        currency_setting: 'Currency',
        categories_followed: 'Followed Categories',
        not_set_categories: 'No categories followed',
        notifications: 'Notifications',
        email_notifications: 'Email notifications',
        push_notifications: 'Push notifications',
        new_recommendations: 'New recommendations',
        rating_updates: 'Rating updates',
        community_updates: 'Community updates',
      },
      editprofile: {
        title: 'Edit Profile',
        basic_info: 'Basic Info',
        username_label: 'Username',
        username_required: 'Please enter username',
        username_placeholder: 'Enter username',
        email_label: 'Email',
        email_required: 'Please enter email',
        email_invalid: 'Invalid email format',
        email_placeholder: 'Enter email address',
        save_changes: 'Save Changes',
        cancel: 'Cancel',
        change_password: 'Change Password',
        current_password: 'Current Password',
        current_password_required: 'Please enter current password',
        current_password_placeholder: 'Current password',
        new_password: 'New Password',
        new_password_required: 'Please enter new password',
        new_password_min: 'At least 6 characters',
        new_password_placeholder: 'New password',
        confirm_password: 'Confirm Password',
        confirm_password_required: 'Please confirm new password',
        confirm_password_mismatch: 'Passwords do not match',
        confirm_password_placeholder: 'Confirm new password',
        update_success: 'Profile updated',
        update_failed: 'Update failed',
        change_password_success: 'Password updated',
        change_password_failed: 'Failed to change password',
        network_error: 'Network error, please try again later',
      },
      dashboard: {
        title: 'Dashboard',
        please_login_title: 'Please login first',
        please_login_desc:
          'Login to view your ratings, favorites and browsing overview.',
        last_7_days: 'Last 7 days',
        last_30_days: 'Last 30 days',
        last_3_months: 'Last 3 months',
        last_1_year: 'Last 1 year',
        refresh: 'Refresh',
        total_ratings: 'Total Ratings',
        total_favorites: 'Total Favorites',
        total_browsed: 'Total Browsed',
        average_rating: 'Average Rating',
        distribution: 'Category Distribution',
        activity_trends: 'Activity Trends',
        ratings_count: 'Ratings',
        favorites_count: 'Favorites',
        my_top_brands: 'Top Brands I Interact',
        industry_comparison: 'Industry Comparison',
        industry_avg: 'Industry Avg',
        my_avg: 'My Avg',
        highlight_title: 'Highlights',
        highlight_text:
          '{{ratings}} ratings, {{favorites}} favorites, avg {{avg}}',
        insights_title: 'Personal Insights',
        insights_env_title: 'Environmental Awareness',
        insights_env_desc: 'You prefer brands with eco certifications',
        insights_social_title: 'Social Responsibility',
        insights_social_desc: 'You value brands with strong labor practices',
        insights_animal_title: 'Animal Protection',
        insights_animal_desc: 'You support cruelty-free brands',
      },
      myratings: {
        title: 'My Ratings',
        login_required: 'Please login to view your ratings',
        loading_failed: 'Failed to load ratings',
        col_brand: 'Brand',
        col_overall: 'Overall',
        col_dimensions: 'Dimensions',
        col_time: 'Time',
        col_actions: 'Actions',
        view_brand: 'View Brand',
        re_rate: 'Rate Again',
        delete_rating: 'Delete Rating',
        confirm_delete_title: 'Confirm delete rating',
        confirm_delete_content: 'This action cannot be undone. Continue?',
        confirm_ok: 'Delete',
        confirm_cancel: 'Cancel',
        delete_success: 'Deleted successfully',
        delete_failed: 'Delete failed',
        empty_title: 'No ratings yet',
        empty_go_to: 'Go to {{page}} to discover more brands',
        pagination_total: 'Items {{start}}-{{end}} of {{total}}',
      },
      myreviews: {
        title: 'My Reviews',
        loading_failed: 'Failed to load reviews',
        sort_label: 'Sort',
        sort_latest: 'Latest',
        sort_oldest: 'Oldest',
        view_brand: 'View Brand',
        edit: 'Edit',
        delete: 'Delete',
        pros_label: 'Pros',
        cons_label: 'Cons',
        empty_title: 'No reviews yet',
        edit_modal_title: 'Edit Review',
        save: 'Save',
        form_content_label: 'Content',
        content_required: 'Please enter content',
        content_placeholder: 'Write your experience...',
        pros_placeholder: 'One pros per line',
        cons_placeholder: 'One cons per line',
        confirm_delete_title: 'Confirm delete this review?',
        confirm_delete_content: 'This action cannot be undone',
        delete_success: 'Deleted successfully',
        delete_failed: 'Delete failed',
      },
      favorites: {
        title: 'My Favorites',
        loading_failed: 'Failed to load favorites',
        empty: 'No favorites yet',
        go_discover: 'Discover',
        total: '{{count}} brands favorited',
        category_distribution: 'By category:',
        remove_favorite: 'Remove Favorite',
        founded_short: 'Founded',
        headquarters_short: 'HQ',
        ethical_score: 'Ethical Score',
      },
      history: {
        title: 'Browsing History',
        loading_failed: 'Failed to load history',
        empty_desc: 'No browsing data yet',
        discover: 'Discover',
        view_details: 'View Details',
        confirm_clear_title: 'Clear browsing history?',
        confirm_ok: 'Clear',
        confirm_cancel: 'Cancel',
        clear_history: 'Clear History',
        days_ago: '{{count}} days ago',
        hours_ago: '{{count}} hours ago',
        just_now: 'Just now',
        visited_times: 'Visited {{count}} times',
        stayed_seconds: 'Stayed {{seconds}} seconds',
      },
      nav: {
        home: 'Home',
        brands: 'Brands',
        rankings: 'Rankings',
        worldMap: 'World Map',
        recommendations: 'Recommendations',
        about: 'About',
      },
      user: {
        profile: 'Profile',
        favorites: 'Favorites',
        history: 'History',
        myRatings: 'My Ratings',
        myReviews: 'My Reviews',
        dashboard: 'Dashboard',
        login: 'Login',
        register: 'Register',
        logout: 'Logout',
      },
      login: {
        title: 'Login',
        subtitle: 'Welcome back, please enter email and password',
        email_required: 'Please enter email',
        email_invalid: 'Invalid email format',
        email_placeholder: 'Email address',
        password_required: 'Please enter password',
        password_placeholder: 'Password',
        forgot_password: 'Forgot password?',
        submit: 'Login',
        no_account: "Don't have an account?",
        register_now: 'Register now',
        back_home: 'Back to Home',
      },
      register: {
        title: 'Register',
        subtitle: 'Create your LuxEthics account',
        email_required: 'Please enter email',
        email_invalid: 'Invalid email format',
        email_placeholder: 'Email address',
        username_placeholder: 'Username (optional)',
        password_required: 'Please enter password',
        password_min: 'Password must be at least 8 characters',
        password_rules:
          'Must include upper/lowercase letters, numbers and a symbol',
        password_placeholder: 'Set password',
        confirm_password_required: 'Please confirm password',
        confirm_password_mismatch: 'Passwords do not match',
        confirm_password_placeholder: 'Confirm password',
        submit: 'Register',
        have_account: 'Already have an account?',
        login_now: 'Login now',
        back_home: 'Back to Home',
      },
      brand: 'LuxEthics',
      about: {
        title: 'About LuxEthics',
        subtitle:
          'Our mission is to empower sustainable, responsible choices with data.',
        note: 'This project is under continuous iteration; data sources and methods will be refined.',
        why_title: 'Why we built this',
        why_p1:
          'Luxury and fashion impact environment, labor rights, animal welfare and transparency.',
        why_p2:
          'Consumers lack accessible, reliable and comparable ethical information.',
        why_p3:
          'We lower information barriers so every purchase moves closer to responsibility.',
        how_title: 'How we work',
        highlights_transparency_title: 'Supply Chain Transparency',
        highlights_transparency_desc:
          'Aggregate public reports and certifications on transparency performance.',
        highlights_workers_title: 'Respect Workers',
        highlights_workers_desc:
          'Focus on safety, wages, fair trade and social responsibility.',
        highlights_environment_title: 'Environment Friendly',
        highlights_environment_desc:
          'Assess material sustainability, decarbonization and circularity.',
        how_data_sources:
          'Sources include certifications, institutional reports, brand disclosures and user evidence.',
        impact_title: 'Social Impact',
        impact_p1:
          'Help consumers vote with wallets and push brand standards upward.',
        impact_p2:
          'Advance transparency and a fair, sustainable global supply chain.',
        join_title: 'Join Us',
        join_contribute:
          'Contribute data and evidence or help translation and terminology.',
        join_feedback:
          'Send feedback to improve UX and evaluation methodology.',
      },
      footer: {
        slogan:
          'Connecting conscience and aesthetics with data and transparency',
        links: 'Quick Links',
        about: 'About',
        browse_brands: 'Browse Brands',
        world_map: 'World Map',
        legal: 'Notes & Disclaimer',
        disclaimer:
          'Some data comes from third-parties and public sources. For reference only.',
        rights_reserved: 'All rights reserved',
        contact: 'Contact',
        contact_email_label: 'Contact Email',
        privacy_policy: 'Privacy Policy',
        terms_of_use: 'Terms of Use',
      },
      legal: {
        privacy_title: 'Privacy Policy',
        privacy_intro:
          'We value your privacy and collect minimal data necessary in compliance with applicable laws.',
        terms_title: 'Terms of Use',
        terms_intro:
          'By using this website, you agree to our terms and community guidelines.',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
